
import {Vue, Component} from 'vue-property-decorator';
import ClientOAuth2 from "client-oauth2";

@Component({})
export default class IcraproHomeView extends Vue {


}
